module.exports = __webpack_public_path__ + "static/img/card.fd152a70.jpg";